module.exports = __webpack_public_path__ + "static/media/social-linkedin.4c926e42.svg";